import { ComponentType, ReactNode } from 'react';

import { Disclosure } from '@headlessui/react';
import { AnimatePresence } from 'framer-motion';
import styled from 'styled-components';

import { Collapse } from '@components/animators/collapse';
import { Rotate } from '@components/animators/Rotate';
import { IconProps } from '@components/icons';
import { IconDropdown } from '@components/icons/dropdown';
import { Text } from '@components/text';
import { theme } from '@styles/theme';
import { pxToRem } from '@utils/converters';
import { transitionSlow } from '@utils/transitions';

export type GroupAccordionProps = {
  label: string;
  children: ReactNode;
  icon: ComponentType<IconProps>;
};

export const GroupAccordion = ({ children, label, icon: Icon }: GroupAccordionProps) => {
  return (
    <Disclosure defaultOpen>
      {({ open }) => (
        <div>
          <Disclosure.Button as={Header}>
            <Container>
              <AnimatePresence initial={false}>
                <Rotate isRotated={!open} degrees={-90}>
                  <IconDropdown key="down" color="elementIndigo200" />
                </Rotate>
              </AnimatePresence>
              <Icon color="elementIndigo200" />
            </Container>
            <Text font="regular14" color="textPrimary" text={label} />
          </Disclosure.Button>
          <Disclosure.Panel static>
            <div style={{ paddingLeft: pxToRem(28) }}>
              <Collapse isCollapsed={!open}>{children}</Collapse>
            </div>
          </Disclosure.Panel>
        </div>
      )}
    </Disclosure>
  );
};

const Header = styled.button({
  borderRadius: pxToRem(4),
  padding: `0 ${pxToRem(8)}`,
  background: 'transparent',
  width: '100%',
  height: pxToRem(32),
  display: 'flex',
  gap: pxToRem(8),
  alignItems: 'center',
  transition: transitionSlow('background'),
  cursor: 'pointer',

  '&:hover': {
    background: theme.color.uiTrans5,
  },
});

const Container = styled.div({
  display: 'flex',
  backgroundColor: theme.color.indigoTrans10,
  borderRadius: pxToRem(4),
  svg: {
    padding: pxToRem(4),
  },
});
